import {Model, sync} from 'backbone';
import {modelMixins} from '../../sinclair/sinclair.mixins';
import urlParser from 'url';
import {stringify} from '../../sinclair/sinclair.markdown';
import {filterHtml} from '../../util/text';

export const URL_FORMAT = /^https?:\/\//i;
export const DEFAULT_MEDIA_CAPTION_MAXLENGTH = 2048;
export const captionFilter = filterHtml.bind(null, {
    a: {
        href: URL_FORMAT,
        target: 1,
    },
});

const MediaModel = Model.extend(
    Object.assign({}, modelMixins.apiDestroyVersion, {
        urlRoot: '/platform/media',
        idAttribute: 'uuid',
        _saveWithOriginal: false,
        _updateOriginQueryParameter: 'updateOriginal',
        _validate(attrs) {
            if (attrs) {
                [attrs, attrs.video, attrs.image, attrs.audio].forEach(obj => {
                    if (obj && obj.caption) {
                        obj.caption = stringify(captionFilter(obj.caption));
                    }
                });
            }
            return Model.prototype._validate.apply(this, arguments);
        },
        getTemplateJSON() {
            const modelJSON = this.toJSON();

            modelJSON.vars = this.vars;
            modelJSON.type = this.type;
            modelJSON.siteId = this.siteId;

            if (modelJSON.type === 'image') {
                modelJSON.model = modelJSON.image;

                delete modelJSON.image;
            } else {
                modelJSON.model = modelJSON.video;

                delete modelJSON.video;
            }

            return modelJSON;
        },
        setUrlRoot(urlRoot) {
            this.urlRoot = urlRoot;

            return this;
        },
        saveWithOriginal(isSave = true) {
            this._saveWithOriginal = isSave;
            return this;
        },
        sync(method, model, options) {
            let url = options.url || (this.url && typeof this.url === 'function' && this.url());

            if (url) {
                url = urlParser.parse(url);
                url.query = Object.assign(url.query || {}, this.getExtraRequestParams(method));
                options.url = urlParser.format(url);
            }

            return sync.call(this, method, model, options);
        },
        getExtraRequestParams(method) {
            if (method !== 'update') {
                return {};
            }
            return {[this._updateOriginQueryParameter]: this._saveWithOriginal};
        },
    }),
);

export default MediaModel;
